export default "<ti-header></ti-header>\n<div id=\"ti-main\" class=\"ti-main\">\n\t<router-outlet></router-outlet>\n</div>\n<ti-footer></ti-footer>\n";